import FooterComponent from "../components/FooterComponent"
import HeaderComponent from "../components/HeaderComponent"
import NewsPageComponent from "../components/NewsPageComponent"

const NewsPage = () => {
    return (
        <>
            <HeaderComponent/>
            <NewsPageComponent/>
            <FooterComponent/>
        </>
    )
}

export default NewsPage